export const mutations = {
    
    printElement(_, { elementId, orientation }) {
        console.log("ori:", orientation);

        // Default orientation is landscape
        orientation = orientation === 'p' ? 'portrait' : 'landscape';

        const originalElement = document.getElementById(elementId);
        if (!originalElement) {
            console.error(`Element with ID "${elementId}" not found.`);
            return;
        }

        // Clone the original element
        const clonedElement = originalElement.cloneNode(true);

        // Clone stylesheets and inline styles
        const stylesheets = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
        const inlineStyles = Array.from(document.querySelectorAll("style"));

        // Create or reuse a hidden iframe
        let printFrame = document.getElementById("print-frame");
        if (!printFrame) {
            printFrame = document.createElement("iframe");
            printFrame.id = "print-frame";
            printFrame.style.position = "absolute";
            printFrame.style.top = "-10000px";
            document.body.appendChild(printFrame);
        }

        const printDocument = printFrame.contentDocument || printFrame.contentWindow.document;

        // Clear the iframe content
        printDocument.open();
        printDocument.write('<html><head></head><body></body></html>');
        printDocument.close();


        const printHtml = printDocument.documentElement; // Get the <html> element
        const originalHtml = document.documentElement; // Get the original <html> element

        // Copy attributes from the original <html> tag
        console.log("step 55 :", originalHtml.attributes);

        Array.from(originalHtml.attributes).forEach(attr => {
            printHtml.setAttribute(attr.name, attr.value);
        });

        const printHead = printDocument.head;
        const printBody = printDocument.body;

        // Copy stylesheets to the iframe
        stylesheets.forEach((sheet) => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = sheet.href;
            printHead.appendChild(link);
        });

        // Copy inline styles to the iframe
        inlineStyles.forEach((style) => {
            const clonedStyle = style.cloneNode(true);
            printHead.appendChild(clonedStyle);
        });

        // Add print-specific CSS
        const printStyle = document.createElement("style");
        printStyle.textContent = `
          @media print {
            .table-responsive {
              overflow-x: unset !important;
            }
              .no-print {
    display: none !important;
  }
            table {
              overflow-y: visible;
              overflow-x: visible;
              width: 100%;
            }
              
            .page-title-box {
              display: block !important;
            }
            @page {
              size: ${orientation};
            }
          }
        `;
        printHead.appendChild(printStyle);

        // Append the cloned content
        printBody.appendChild(clonedElement);

        // Debugging: Log iframe content
        console.log(printDocument.documentElement.outerHTML);

        // Delay to ensure content is rendered before printing
        setTimeout(() => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();
        }, 500); // Adjust delay if necessary
    }
};

export const actions = {
    printElement({ commit }, elementId) {
        commit('printElement', elementId)
    }
};